import React from 'react'
import tools from '../../tools'

// Pastilles de langues (remplace les drapeaux de LangSelector dans les vues harmonisées).
// - translations + fields : colore selon l'état de traduction (vert = complet, orange ! = manquant)
// - current : met la langue active en indigo (mode sélecteur)
// - onSelect : rend les pastilles cliquables (changement de langue)
const LangPills = ({ langs, translations = null, fields = null, current = null, onSelect = null }) => {
	if (!langs || !langs.length)
		return null
	return (
		<span className="inline-flex flex-wrap items-center">
			{langs.map((lang) => {
				let classes = "bg-gray-100 focus:bg-gray-100 text-gray-600"
				let suffix = ''
				if (translations && fields)
				{
					const missing = (tools.getMissingLangs(translations, [lang], fields).length > 0)
					if (missing)
					{
						classes = "bg-yellow-100 focus:bg-yellow-100 text-yellow-700"
						suffix = ' !'
					}
					else
						classes = "bg-green-50 focus:bg-green-50 text-green-700"
				}
				if (current === lang)
				{
					classes = "bg-indigo-600 focus:bg-indigo-600 text-white"
					suffix = ''
				}
				if (!onSelect)
					return (<span key={lang} className={"text-xs font-bold uppercase rounded-md px-2 py-1 mr-1 " + classes}>{lang}{suffix}</span>)
				return (
					<button
						key={lang}
						type="button"
						onClick={() => onSelect(lang)}
						aria-label={"Passer en " + lang.toUpperCase()}
						className={"text-xs font-bold uppercase rounded-md px-2 py-1 mr-1 " + classes}
						style={{ backgroundImage: 'none', border: 'none', boxShadow: 'none', cursor: 'pointer' }}
					>{lang}{suffix}</button>
				)
			})}
		</span>
	)
}

export default LangPills
